var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'd-flex d-flex-center profile-picture',
    { 'is-team': _vm.isTeam },
    _vm.firstLetter,
  ],style:({ 'background-image': _vm.profileBg })},[(_vm.isTeam && _vm.firstLetter)?_c('label',[_vm._v(_vm._s(_vm.firstLetter))]):_vm._e(),(_vm.enableHover)?_c('label',{staticClass:"hover-label"},[_vm._v(_vm._s(_vm.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }